const performance = window.performance

export default performance
